export const VALID_ASSET_TYPES = [
    "screenshot",
    "video",
    "trace",
    "lighthouse",
];
export const generateErrorReport = ({ location, snippet }) => {
    if (!location)
        return null;
    const { file, line, column } = location;
    return `# ${file} (${line}:${column}) \n\n\n ${snippet}`;
};
export const BYTES_DIVISOR = { KB: 1024, MB: Math.pow(1024, 2) };
//# sourceMappingURL=onTestEnd.js.map